import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful';

import type { TypeBlogArticleSkeleton } from './TypeBlogArticle';
import type { TypeCtaSkeleton } from './TypeCta';

export interface TypeBlockArticlesFields {
    internalName: EntryFieldTypes.Symbol;
    title?: EntryFieldTypes.Symbol;
    displayOption?: EntryFieldTypes.Symbol<'1:1:1' | '1:2' | '1:3' | 'standalone'>;
    colorOption?: EntryFieldTypes.Symbol<'color-light-beige' | 'color-no-background'>;
    articles?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeBlogArticleSkeleton>>;
    cta?: EntryFieldTypes.EntryLink<TypeCtaSkeleton>;
}

export type TypeBlockArticlesSkeleton = EntrySkeletonType<TypeBlockArticlesFields, 'blockArticles'>;
export type TypeBlockArticles<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
    TypeBlockArticlesSkeleton,
    Modifiers,
    Locales
>;

export function isTypeBlockArticles<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
    entry: unknown,
): entry is TypeBlockArticles<Modifiers, Locales> {
    const candidate = entry as { sys?: { contentType?: { sys?: { id?: string } } } };

    return candidate.sys?.contentType?.sys?.id === 'blockArticles';
}
